export const getCart = async () => (await fetch(`${theme.endpoints.cart}.js`)).json();

export const removeItem = async (key) => {
  const data = new FormData();
  data.append('id', key);
  data.append('quantity', '0');

  return (
    await fetch(`${theme.endpoints.cartChange}.js`, {
      method: 'post',
      body: data,
    })
  ).json();
};

export default {
  getCart,
  removeItem,
};
